/*
 * Keeps the product page price in step with what the shopper is about to buy:
 * - the selected "Bundle and save" tier from the SMART Discounts widget, or
 * - the quantity box (unit price x quantity) when no bundle tier is selected.
 * The currency estimate under the price follows the same amount.
 */
(function () {
  if (window.__bundlePriceSync) return;
  window.__bundlePriceSync = true;

  function parseCents(text) {
    var match = (text || '').match(/[0-9][0-9.,]*/);
    if (!match) return null;
    var cleaned = match[0];
    var lastDot = cleaned.lastIndexOf('.');
    var lastComma = cleaned.lastIndexOf(',');
    if (lastComma > lastDot && cleaned.length - lastComma === 3) {
      cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    } else {
      cleaned = cleaned.replace(/,/g, '');
    }
    var value = parseFloat(cleaned);
    return isNaN(value) ? null : Math.round(value * 100);
  }

  function formatLike(sample, cents) {
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return sample.replace(/[0-9][0-9.,]*/, amount);
  }

  function scopeOf(node) {
    return node.closest('product-info, section, .shopify-section') || document;
  }

  function priceWrapIn(scope) {
    return scope.querySelector('[id^="price-"]');
  }

  function originalsOf(wrap) {
    return Array.prototype.filter.call(wrap.children, function (el) {
      return !el.hasAttribute('data-bundle-price');
    });
  }

  function clear(wrap) {
    var bundleEl = wrap.querySelector('[data-bundle-price]');
    if (bundleEl) bundleEl.remove();
    originalsOf(wrap).forEach(function (el) { el.hidden = false; });
  }

  function show(wrap, priceText, compareText) {
    var bundleEl = wrap.querySelector('[data-bundle-price]');
    if (!bundleEl) {
      bundleEl = document.createElement('div');
      bundleEl.setAttribute('data-bundle-price', '');
      wrap.appendChild(bundleEl);
    }
    var key = priceText + '|' + compareText;
    if (bundleEl.dataset.key !== key) {
      bundleEl.dataset.key = key;
      bundleEl.className = 'price price--large' + (compareText ? ' price--on-sale' : '');
      bundleEl.innerHTML = '';
      var container = document.createElement('div');
      container.className = 'price__container';
      var row = document.createElement('div');
      row.className = compareText ? 'price__sale' : 'price__regular';
      if (compareText) {
        var s = document.createElement('s');
        s.className = 'price-item price-item--regular';
        s.textContent = compareText;
        row.appendChild(s);
        row.appendChild(document.createTextNode(' '));
      }
      var current = document.createElement('span');
      current.className = 'price-item ' + (compareText ? 'price-item--sale ' : 'price-item--regular ') + 'price-item--last';
      current.textContent = priceText;
      row.appendChild(current);
      container.appendChild(row);
      bundleEl.appendChild(container);
    }
    originalsOf(wrap).forEach(function (el) { el.hidden = true; });
  }

  function updateEstimate(scope, cents) {
    var estimate = scope.querySelector('currency-estimate');
    if (!estimate || cents === null || typeof estimate.render !== 'function') return;
    if (estimate.price !== cents) {
      estimate.price = cents;
      estimate.render();
    }
  }

  function unitPriceText(wrap) {
    var originals = originalsOf(wrap);
    for (var i = 0; i < originals.length; i++) {
      var price = originals[i].matches('.price') ? originals[i] : originals[i].querySelector('.price');
      if (!price) continue;
      var onSale = price.classList.contains('price--on-sale');
      var current = price.querySelector(onSale ? '.price__sale .price-item--last' : '.price__regular .price-item--regular');
      var compare = onSale ? price.querySelector('.price__sale s.price-item--regular') : null;
      if (current) {
        return { price: current.textContent.trim(), compare: compare ? compare.textContent.trim() : '' };
      }
    }
    return null;
  }

  function render(scope) {
    var wrap = priceWrapIn(scope);
    if (!wrap) return;

    var active = scope.querySelector('.bd-widget .bd-tier--active');
    var tierPrice = active && active.querySelector('.bd-tier__price');
    var compareNode = active && active.querySelector('.bd-tier__compare');
    if (!tierPrice) {
      active = scope.querySelector('.sw-offer--selected');
      tierPrice = active && active.querySelector('.sw-price .sw-price-total');
      compareNode = active && active.querySelector('.sw-price .sw-price-compare');
    }
    if (tierPrice) {
      var priceText = tierPrice.textContent.trim();
      show(wrap, priceText, compareNode ? compareNode.textContent.trim() : '');
      updateEstimate(scope, parseCents(priceText));
      return;
    }

    var qtyInput = scope.querySelector('input[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!qty || qty < 1) qty = 1;

    var unit = unitPriceText(wrap);
    if (!unit) return;
    var unitCents = parseCents(unit.price);
    if (unitCents === null) return;

    if (qty <= 1) {
      clear(wrap);
    } else {
      var compareCents = unit.compare ? parseCents(unit.compare) : null;
      show(
        wrap,
        formatLike(unit.price, unitCents * qty),
        compareCents ? formatLike(unit.compare, compareCents * qty) : ''
      );
    }
    updateEstimate(scope, unitCents * qty);
  }

  var watched = new WeakSet();

  function watch(scope) {
    if (watched.has(scope)) return;
    watched.add(scope);
    var queued = false;
    var schedule = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        render(scope);
      });
    };
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var target = records[i].target;
        if (target.closest && target.closest('[data-bundle-price]')) continue;
        schedule();
        return;
      }
    }).observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'value'] });
    scope.addEventListener('change', schedule);
    scope.addEventListener('input', schedule);
    scope.addEventListener('click', function () { setTimeout(schedule, 50); });
    schedule();
  }

  function scan() {
    document.querySelectorAll('[id^="price-"]').forEach(function (wrap) {
      var scope = scopeOf(wrap);
      if (scope !== document) watch(scope);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  window.addEventListener('load', scan);
})();
